<template>
  <div class="nomal-combo">
    <div class="tuolele-main-box">
      <div class="data-form-title">设置套餐的具体内容</div>
      <el-form label-position="right" label-width="130px">
        <el-form-item label="套餐类型" required>
          <el-select
            v-model="item_type"
            placeholder="请选择"
            :disabled="isCreate"
          >
            <el-option
              v-for="item in typeList"
              :key="item.value"
              :label="item.text"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="设置套餐详情" required>
          <div>
            <table>
              <tr>
                <td />
                <td>扣费方式</td>
                <td>套餐课时</td>
                <!-- <td>赠送课时</td> -->
                <td>套餐（原价）</td>
                <td>
                  套餐（实际销售价）
                  <el-tooltip class="item" effect="dark" placement="top">
                    <div slot="content">
                      <p class="el-tooltip__popper-text">
                        操作提示：
                        <br>1、常规套餐（实际销售价）和假期套餐（实际销售价），两者为必填项
                        <br>2、常规套餐（实际销售价）必须小于等于常规套餐（原价）
                        <br>3、假期套餐（实际销售价）必须小于等于假期套餐（原价
                      </p>
                    </div>
                    <i class="el-icon-question" />
                  </el-tooltip>
                </td>
              </tr>

              <tr>
                <td>常规</td>
                <td>日扣</td>
                <td>
                  <input
                    v-model="formalDayObj.other_day"
                    type="text"
                    placeholder="请输入"
                    :disabled="isCreate"
                  >天
                </td>
                <!-- <td>
                  <input
                    v-model="formalDayObj.give_day_time"
                    type="text"
                    placeholder="请输入"
                    :disabled="isCreate"
                  >天
                </td> -->
                <td>
                  <input
                    v-model="formalDayObj.price"
                    type="text"
                    placeholder="请输入"
                    :disabled="isCreate"
                  >元
                </td>
                <td>
                  <input
                    v-model="formalDayObj.real_price"
                    type="text"
                    placeholder="请输入"
                    :disabled="isCreate"
                  >元
                </td>
              </tr>

            </table>
          </div>
        </el-form-item>

        <el-form-item v-if="!isCreate">
          <el-button type="primary" @click="saveCombo">生成套餐</el-button>
          <el-tooltip class="item" effect="dark" placement="top">
            <div slot="content">
              <p class="el-tooltip__popper-text">
                操作提示：
                <br>1、请点击“生成套餐”按钮，系统将为您自动显示套餐详情
                <br>2、点击“修改套餐”按钮，可以继续编辑套餐详情
                <br>3、确认无误后，即可点击“提交套餐”按钮，系统将根据套餐预览详情，正式生成套餐！
              </p>
            </div>
            <i class="el-icon-question" />
          </el-tooltip>
        </el-form-item>
      </el-form>
    </div>
    <div v-if="isCreate" class="tuolele-main-box">
      <div class="data-form-title">套餐详情预览</div>
      <div class="self-table">
        <div class="table-name">套餐名称 {{ comboShow.item_title }}</div>
        <div class="table-content">
          <table>
            <thead>
              <tr>
                <td />
                <td>扣费方式</td>
                <td>套餐课时</td>
                <!-- <td>赠送课时</td> -->
                <td>套餐（原价）</td>
                <td>套餐（实际销售价）</td>
                <td>日均课耗</td>
                <td>日均退费</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>常规</td>
                <td>日扣</td>
                <td>{{ formalDayObj.other_day - 0 }}天</td>
                <!-- <td>{{ formalDayObj.give_day_time - 0 }}天</td> -->
                <td>{{ formalDayObj.price - 0 }}</td>
                <td>{{ formalDayObj.real_price - 0 }}</td>
                <td>{{ dayItemPrice }}</td>
                <td>{{ dayItemRefundPrice }}</td>
              </tr>

            </tbody>
          </table>

        </div>
        <el-button type="info" @click="isCreate = false">修改套餐</el-button>
        <el-button type="primary" @click="postCombo">提交套餐</el-button>
      </div>
    </div>
  </div>
</template>

<script>

import Select from '@/components/Select'
import commondata from '@/utils/commondata'
import Tool from '@/assets/js/tool.js'

export default {
  name: 'NomalCombo',
  components: {
    Select
  },
  props: {
    type: [String, Number],
    itemTitle: String,
    limitedNumber: [String, Number],
    gradeId: String,
    isSupplementaryAgreement: [String, Number]
  },
  data() {
    return {
      typeList: [
        { text: '常规', value: '50' }
        // { text: '假期', value: '2' },
        // { text: "常日+假日", value: "6" },
        // { text: "常日+假月", value: "7" },
        // { text: "常月+假日", value: "8" },
        // { text: "常月+假月", value: "9" },
        // { text: '常规周末', value: '31' },
        // { text: '假期周末', value: '41' }
      ],
      subjectLists: commondata.XXS_SUBJECT_LISTS,
      xxsCourseLists: commondata.XXS_COURSE_TYPE,
      formalMonthCost: '1',
      holidayMonthCost: '1',
      item_type: '50',
      formalDayObj: {
        other_day: '',
        // give_day_time: '',
        price: '',
        real_price: ''
      },
      comboShow: {
        type: '',
        item_title: '',
        limited_number: '',
        grade_id: '',
        item_type: '',
        total_price: '',
        is_supplementary_agreement: '',
        original_price: ''
      },
      isCreate: false
    }
  },
  computed: {
    dayItemPrice() {
      if (this.formalDayObj.real_price == 0) {
        return 0
      } else {
        return Tool.calcuateMoney(
          (this.formalDayObj.real_price - 0) /
            (this.formalDayObj.other_day -
              0)
        )
      }
    },
    dayItemRefundPrice() {
      if (this.formalDayObj.price == 0) {
        return 0
      } else {
        return Tool.calcuateMoney(
          (this.formalDayObj.price - 0) /
            (this.formalDayObj.other_day - 0)
        )
      }
    },

    dayHolidayPrice() {
      if (this.holidayDayObj.real_price == 0) {
        return 0
      } else {
        return Tool.calcuateMoney(
          (this.holidayDayObj.real_price - 0) /
            (this.holidayDayObj.holiday_day_time -
              0 +
              (this.holidayDayObj.holiday_give_day_time - 0))
        )
      }
    },
    dayHolidayRefundPrice() {
      if (this.holidayDayObj.price == 0) {
        return 0
      } else {
        return Tool.calcuateMoney(
          (this.holidayDayObj.price - 0) /
            (this.holidayDayObj.holiday_day_time - 0)
        )
      }
    },
    weekItemPrice() {
      if (this.weekDayObj.real_price == 0) {
        return 0
      } else {
        return Tool.calcuateMoney(
          (this.weekDayObj.real_price - 0) /
            (this.weekDayObj.week_day -
              0 +
              (this.weekDayObj.week_give_day - 0))
        )
      }
    },
    formalWeekendItemPrice() {
      if (this.formalWeekendDayObj.real_price == 0) {
        return 0
      } else {
        return Tool.calcuateMoney(
          (this.formalWeekendDayObj.real_price - 0) /
            (this.formalWeekendDayObj.formal_weekend_day -
              0 +
              (this.formalWeekendDayObj.formal_weekend_give_day - 0))
        )
      }
    },
    formalWeekendItemRefundPrice() {
      if (this.formalWeekendDayObj.price == 0) {
        return 0
      } else {
        return Tool.calcuateMoney(
          (this.formalWeekendDayObj.price - 0) /
            (this.formalWeekendDayObj.formal_weekend_day - 0)
        )
      }
    },
    formalWeekendHolidayPrice() {
      if (this.formalWeekendHolidayDayObj.real_price == 0) {
        return 0
      } else {
        return Tool.calcuateMoney(
          (this.formalWeekendHolidayDayObj.real_price - 0) /
            (this.formalWeekendHolidayDayObj.holiday_weekend_day -
              0 +
              (this.formalWeekendHolidayDayObj.holiday_weekend_give_day - 0))
        )
      }
    },
    formalWeekendHolidayRefundPrice() {
      if (this.formalWeekendHolidayDayObj.price == 0) {
        return 0
      } else {
        return Tool.calcuateMoney(
          (this.formalWeekendHolidayDayObj.price - 0) /
            (this.formalWeekendHolidayDayObj.holiday_weekend_day - 0)
        )
      }
    },
    weekItemRefundPrice() {
      if (this.weekDayObj.price == 0) {
        return 0
      } else {
        return Tool.calcuateMoney(
          (this.weekDayObj.price - 0) /
            (this.weekDayObj.week_day - 0)
        )
      }
    },
    weekHolidayPrice() {
      if (this.holidayWeekDayObj.real_price == 0) {
        return 0
      } else {
        return Tool.calcuateMoney(
          (this.holidayWeekDayObj.real_price - 0) /
            (this.holidayWeekDayObj.holiday_week_day -
              0 +
              (this.holidayWeekDayObj.holiday_week_give_day - 0))
        )
      }
    },

    weekHolidayRefundPrice() {
      if (this.holidayWeekDayObj.price == 0) {
        return 0
      } else {
        return Tool.calcuateMoney(
          (this.holidayWeekDayObj.price - 0) /
            (this.holidayWeekDayObj.holiday_week_day - 0)
        )
      }
    },
    monthItemPrice() {
      if (this.formalMonthObj.real_price == 0) {
        return 0
      } else {
        return Tool.calcuateMoney(
          (this.formalMonthObj.real_price - 0) /
            (this.formalMonthObj.formal_month * 30 +
              (this.formalMonthObj.formal_day - 0) +
              (this.formalMonthObj.give_day - 0))
        )
      }
    },
    monthItemRefundPrice() {
      if (this.formalMonthObj.price == 0) {
        return 0
      } else {
        return Tool.calcuateMoney(
          (this.formalMonthObj.price - 0) /
            (this.formalMonthObj.formal_month * 30 +
              (this.formalMonthObj.formal_day - 0))
        )
      }
    },
    monthHolidayPrice() {
      if (this.holidayMonthObj.real_price == 0) {
        return 0
      } else {
        return Tool.calcuateMoney(
          (this.holidayMonthObj.real_price - 0) /
            (this.holidayMonthObj.holiday_month * 30 +
              (this.holidayMonthObj.holiday_day - 0) +
              (this.holidayMonthObj.holiday_give_day - 0))
        )
      }
    },
    monthHolidayRefundPrice() {
      if (this.holidayMonthObj.price == 0) {
        return 0
      } else {
        return Tool.calcuateMoney(
          (this.holidayMonthObj.price - 0) /
            (this.holidayMonthObj.holiday_month * 30 +
              (this.holidayMonthObj.holiday_day - 0))
        )
      }
    }
  },
  watch: {
    formalMonthCost(val) {
      if (val == 1) {
        this.formalMonthObj.formal_month = ''
      } else {
        this.formalMonthObj.formal_day = ''
      }
    },
    holidayMonthCost(val) {
      if (val == 1) {
        this.holidayMonthObj.holiday_month = ''
      } else {
        this.holidayMonthObj.holiday_day = ''
      }
    }
  },
  mounted() {

  },
  methods: {
    async postCombo() {
      this.comboShow.type = this.type
      this.comboShow.item_title = this.itemTitle
      this.comboShow.grade_id = this.gradeId
      this.comboShow.limited_number = this.limitedNumber
      this.comboShow.is_supplementary_agreement = this.isSupplementaryAgreement
      this.comboShow.item_type = this.item_type
      // if (this.comboShow.combineLists.length > 0) {
      //   this.comboShow.combineJson = JSON.stringify(this.comboShow.combineLists)
      // }

      const ret = await this.$http.improveItem(this.comboShow)
      if (ret.code == 200) {
        this.$message({
          type: 'success',
          message: '操作成功'
        })
        this.$router.go(-1)
      }
    },
    saveCombo() {
      if (this.itemTitle == '') {
        this.$message({
          message: '套餐名称不能为空',
          type: 'warning'
        })
        return false
      }
      if (this.gradeId == '') {
        this.$message({
          message: '请选择适用年级',
          type: 'warning'
        })
        return false
      }
      this.comboShow = {
        type: '',
        item_title: '',
        limited_number: '',
        grade_id: '',
        item_type: '',
        total_price: '',
        combineLists: this.xxsGiveLists
      }
      this.saveNormalCombo()
    },
    saveNormalCombo() {
      var flag1 = false
      for (const key in this.formalDayObj) {
        if (this.formalDayObj.hasOwnProperty(key)) {
          if (this.formalDayObj[key] != '') {
            flag1 = true
          }
        }
      }

      if (!flag1) {
        this.$message({
          message: '请将套餐信息填写完整',
          type: 'warning'
        })
        return false
      }
      this.comboShow.type = this.type
      this.comboShow.item_title = this.itemTitle
      this.comboShow.grade_id = this.gradeId
      this.comboShow.limited_number = this.limitedNumber
      this.comboShow.item_type = this.item_type
      if (flag1) {
        let empty = false
        console.log(this.formalDayObj)
        for (const key in this.formalDayObj) {
          if (this.formalDayObj.hasOwnProperty(key)) {
            if (this.formalDayObj[key] == '') {
              console.log(key)
              empty = true
            }
          }
        }
        if (empty) {
          this.$message({
            message: '请将套餐信息填写完整',
            type: 'warning'
          })
          return false
        }
        this.comboShow.item_price = Tool.calcuateMoney(
          this.formalDayObj.real_price /
            (this.formalDayObj.other_day -
              0)
        )
        this.comboShow.item_refund_price = Tool.calcuateMoney(
          this.formalDayObj.price / (this.formalDayObj.other_day - 0)
        )
        this.comboShow.other_day = this.formalDayObj.other_day
        // this.comboShow.give_day_time = this.formalDayObj.give_day_time
        this.comboShow.total_price = this.formalDayObj.real_price
        this.comboShow.original_price = this.formalDayObj.price
        this.comboShow.item_total_price = this.formalDayObj.real_price
      }
      this.isCreate = true
    },

    fnCreateXXSGiveList: function() {
      this.xxsGiveLists.push({
        subject_id: '',
        course_type: '',
        num: 0
      })
    },
    fnDeleteXXSData: function(index) {
      this.xxsGiveLists.splice(index, 1)
    },
    fnFindCourseType: function(course_type) {
      var index = Tool.findIndexInArryByKeyVal(this.xxsCourseLists, 'id', course_type)
      if (index > -1) {
        return this.xxsCourseLists[index].name
      }
      return ''
    },
    fnFindSubjectId: function(subject_id) {
      var index = Tool.findIndexInArryByKeyVal(this.subjectLists, 'id', subject_id)
      if (index > -1) {
        return this.subjectLists[index].name
      }
      return ''
    }
  }
}
</script>
<style lang="scss" scoped>
.nomal-combo {
  .data-form-title {
    font-size: 20px;
    margin-bottom: 30px;
    color: $color_black;
  }
  .self-table {
    .table-name {
      height: 60px;
      background-color: $color_blue;
      opacity: 0.7;
      line-height: 60px;
      color: #fff;
      text-align: center;
      font-size: 14px;
    }
    .el-button {
      margin-top: 40px;
    }
  }
  ::v-deep .el-form {
    .el-form-item {
      margin-bottom: 20px;
      color: $color_black;
      .el-form-item__label {
        margin-right: 20px;
        padding-right: 0;
        &:before {
          color: $color_blue;
        }
      }
      i {
        font-style: normal;
        margin-left: 10px;
      }
      b {
        font-weight: normal;
        color: $color_normal;
      }
    }
    .el-input {
      width: 180px;
    }
    table {
      text-align: center;
      border-top: 1px solid #ebebeb;
      border-right: 1px solid #ebebeb;
      width: 95%;
      box-sizing: border-box;
      td {
        padding: 20px 0;
        border-left: 1px solid #ebebeb;
        border-bottom: 1px solid #ebebeb;
        .el-icon-question {
          margin: 0;
          width: auto;
          height: auto;
        }
        input {
          width: 60px;
          outline: none;
        }
        p {
          color: $color_normal;
          width: 130px;
          text-align: left;
          margin: 0 auto;
        }
        div {
          width: 130px;
          text-align: left;
          margin: 0 auto;
        }
      }
    }
  }
}

.xxs_preview {
  margin-top:10px;
  color:#333333;
}

.xxs-form-box {
    ::v-deep .el-form-item {
    .el-input {
      width: 100%!important;
    }
  }
  .wq_flex{
    margin-bottom:10px
  }
  .wq_flex::nth-child(n+1) {
    padding-left:20px
  }
}

.el-button {
  width: 120px;
  height: 40px;
}
.wq_flex {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
}

.wq_flex_wrap {
  flex-wrap: wrap;
}

.wq_flex_sub {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
}

.wq_margin_auto {
  margin: auto;
}

.wq_flex_middle {
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
}
</style>
